import { loadPage, observeOnce } from "./utils"
import VanillaFittty from "shared/scripts/vanilla_fittty"
import { onBFCacheLoad } from "shared/scripts/back_forward_cache_utils"
import { trackSearchPerformed } from "app/utils/mixpanel_tracking"

const SEARCH_ORIGIN_KEY = "explore_search_origin"

const isSearchPage = (url: URL) =>
  url.pathname.startsWith("/search/query/") || url.searchParams.get("view") === "search"

/**
 * The standard back button steps back one page. After a follow-up search that
 * page is the previous results page, so point it at the page the search began on.
 */
export const SearchBackButton = () => {
  const link = document.querySelector<HTMLAnchorElement>(".secondary-header-back a")
  if (!link) return

  const referrer = document.referrer ? new URL(document.referrer) : null
  if (referrer?.hostname !== window.location.hostname) {
    sessionStorage.removeItem(SEARCH_ORIGIN_KEY)
    return
  }

  if (!isSearchPage(referrer)) {
    sessionStorage.setItem(SEARCH_ORIGIN_KEY, `${referrer.pathname}${referrer.search}`)
    return
  }

  const searchOrigin = sessionStorage.getItem(SEARCH_ORIGIN_KEY)
  if (searchOrigin) link.setAttribute("href", searchOrigin)
  link.removeAttribute("onclick")
}

/**
 * Explore has no search field of its own: the header search navigates to
 * /search/query/:term, which renders this page's server-side search view. This
 * pages in more applets on scroll and reports the search to Mixpanel.
 */
export const Search = () => {
  const {
    currentView,
    moreAppletsForSearchPath,
    searchTerm = "",
  } = document.querySelector(".explore-discover-container").dataset

  if (currentView !== "search") return

  SearchBackButton()

  const searchResultContainer = document.querySelector(".search-view-container")
  const searchOffset = 32
  const minimumAppletsToLoad = 100

  let currentOffset = 32

  const fetchSearchResultMoreApplets = () => {
    const appletSearchContainer = document.querySelector(".explore-search")
    if (!appletSearchContainer) return

    const element = appletSearchContainer.querySelector(".explore-tile[data-sentinel='true']")
    if (!element) return

    element.dataset.sentinel = "false"

    observeOnce(element, () => {
      const searchMorePath = `${moreAppletsForSearchPath}/${encodeURIComponent(searchTerm)}/${currentOffset}`
      const appletsFromSearch = appletSearchContainer.querySelectorAll(".explore-tile").length
      currentOffset += searchOffset

      // After achieve the minimumAppletsToLoad, don't need to ask for more
      if (appletsFromSearch < minimumAppletsToLoad) {
        loadPage(searchMorePath).then(html => {
          appletSearchContainer.insertAdjacentHTML("beforeend", html)
          void VanillaFittty(searchResultContainer as HTMLElement)
          document.addEventListener("scroll", fetchSearchResultMoreApplets, { once: true })
          window.App.Utils.logCustomDatadogAction("explore_search_completed", {
            searchTerm: searchTerm.toLowerCase(),
          })
        })
      }
    })
  }

  document.addEventListener("scroll", fetchSearchResultMoreApplets, { once: true })

  trackSearchPerformed({
    term: searchTerm,
    appletResultCount: searchResultContainer.querySelectorAll("[data-type='applet']").length,
    serviceResultCount: searchResultContainer.querySelectorAll("[data-type='service']").length,
  })

  onBFCacheLoad("explore_search", () => {
    Search()
  })
}
